module.exports = __webpack_public_path__ + "static/img/obtainingTitles.647e2670.png";